import axios from "axios";
export default {
    getTaskLogsForDocument: (documentId) => axios.post("/Tasks/GetDocumentTasksLog", { documentId })
};
